// extracted by css-extract-rspack-plugin
module.exports =  {"aff_loading":"UIYVc","affspin":"DggEW"};